import React, { useEffect, useState } from 'react';
import './MultiStepForm.css'
import OverviewStep from './steps/OverviewStep';
import Step1 from './steps/Step1';
import Step2 from './steps/Step2';
import Step3 from './steps/Step3';
import Step4 from './steps/Step4';
import Step5 from './steps/Step5';
import Step6 from './steps/Step6';
import UserData from './steps/UserData';
import ResultStep from './steps/ResultStep';
import CalendlyStep from './steps/CalendlyStep';


const MultiStepForm = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({});


useEffect(() => {
  console.log(formData);
}, [formData]);

  // const [isSubmitting, setIsSubmitting] = useState(false); // Reservado para uso futuro

  const [completedSteps, setCompletedSteps] = useState({
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
    8: false,
    9: false
  });

  const nextStep = () => {
    setCompletedSteps({
      ...completedSteps,
      [currentStep]: true
    });
    setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleInputChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value
    });
  };

  // submitFormData función reservada para uso futuro con API
  // const submitFormData = async () => {
  //   try {
  //     setIsSubmitting(true);
  //     const response = await fetch('your-api-endpoint', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify(formData)
  //     });
  //     if (!response.ok) {
  //       throw new Error('Error al enviar los datos');
  //     }
  //     const result = await response.json();
  //     console.log('Datos enviados exitosamente:', result);
  //     setCompletedSteps({
  //       ...completedSteps,
  //       [currentStep]: true,
  //       8: true
  //     });
  //     nextStep();
  //   } catch (error) {
  //     console.error('Error:', error);
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  const canAccessStep9 = () => {
    return Object.entries(completedSteps)
      .slice(0, 8) // Tomar solo los primeros 8 pasos
      .every(([_, completed]) => completed);
  };

  const handleStepClick = (stepNumber) => {
    if (stepNumber === 9 && canAccessStep9()) {
      setCurrentStep(stepNumber);
    } else if (completedSteps[stepNumber]) {
      setCurrentStep(stepNumber);
    }
  };

  const renderProgressBar = () => {
    const steps = [
      { number: 1, label: 'Inicio' },
      { number: 2, label: 'Quilates' },
      { number: 3, label: 'Corte' },
      { number: 4, label: 'Color' },
      { number: 5, label: 'Pureza' },
      { number: 6, label: 'Montura' },
      { number: 7, label: 'Material' },
      { number: 8, label: 'Datos' },
      { number: 9, label: 'Cotizar' }
    ];

    return (
      <div className="progress-bar">
        {steps.map((step, index) => (
          <div 
            key={step.number} 
            className={`progress-step ${currentStep === step.number ? 'active' : ''} ${completedSteps[step.number] ? 'completed' : ''}`}
            onClick={() => handleStepClick(step.number)}
            style={{cursor: (step.number === 9 && canAccessStep9()) || completedSteps[step.number] ? 'pointer' : 'not-allowed'}}
          >
            <div className="step-number-wrapper">
            <div className="step-number">{step.number}</div>
            <div className="step-label">{step.label}</div>
              </div>
            
            {index < steps.length - 1 && <div className="step-connector" />}
          </div>
        ))}
      </div>
    );
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <OverviewStep
            nextStep={nextStep}
            handleInputChange={handleInputChange}
            formData={formData}
          />
        );
      case 2:
        return (
          <Step1
            nextStep={nextStep}
            prevStep={prevStep}
            handleInputChange={handleInputChange}
            formData={formData}
          />
        );
      case 3:
        return (
          <Step2
            nextStep={nextStep}
            prevStep={prevStep}
            handleInputChange={handleInputChange}
            formData={formData}
          />
        );
      case 4:
        return (
          <Step3
            nextStep={nextStep}
            prevStep={prevStep}
            handleInputChange={handleInputChange}
            formData={formData}
          />
        );
      case 5:
        return (
          <Step4
            nextStep={nextStep}
            prevStep={prevStep}
            handleInputChange={handleInputChange}
            formData={formData}
          />
        );
      case 6:
        return (
          <Step5
            nextStep={nextStep}
            prevStep={prevStep}
            handleInputChange={handleInputChange}
            formData={formData}
          />
        );
      case 7:
        return (
          <Step6
            nextStep={nextStep}
            prevStep={prevStep}
            handleInputChange={handleInputChange}
            formData={formData}
          />
        );
        case 8:
        return (
          <UserData
            nextStep={nextStep}
            prevStep={prevStep}
            handleInputChange={handleInputChange}
            formData={formData}
          />
        );
      case 9:
        return (
          <ResultStep
            prevStep={prevStep}
            formData={formData}
            nextStep={nextStep}
          />
        );
        case 10:
        return (
          <CalendlyStep
          nextStep={nextStep}
            prevStep={prevStep}
            formData={formData}
          />
        );

      default:
        return null;
    }
  };

  return (
    <div className="multi-step-form">
      {renderProgressBar()}
      {renderStep()}
    </div>
  );
};

export default MultiStepForm;
